angular.module('dnecom.component.currency')
    .directive('currencyReal', ["CurrencyRates", "CurrencyConverter", "CurrencyFormatter", function(CurrencyRates, CurrencyConverter, CurrencyFormatter) {
        return {
            restrict: 'E',
            scope: {
                amount: "="
            },
            template: "{{ getFormattedAmount() }}",
            link: function(scope) {

                scope.getFormattedAmount = function() {
                    return CurrencyFormatter.formatReal(scope.amount, CurrencyRates.fetchStoreCurrency());
                };
            }
        };
    }]);
